import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Grid,
  IconButton,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import { truncateComment } from "utils/utils";
import { billingTypeEnum } from "utils/enumObj";
import Confirm from "assets/images/Confirm.svg";
import DownloadIcon from "assets/images/DownloadBlue.svg";
import pdf from "assets/images/pdf.svg";
import word from "assets/images/doc.svg";
import "./ConfirmModal.scss";

import NotifyRecipientsModal from "components/notifyRecipientsModal/NotifyRecipientsModal";
import CommonButton from "components/commonButton/CommonButton";

const ConfirmModal = ({ open, toggle, navigate, pageName, companyProfile }) => {
  const [notifyModalOpen, setNotifyModalOpen] = useState(false);

  const isReservationConfirm = ![
    "assignDriver",
    "assignVehicle",
    "companyDetails",
  ].includes(pageName);

  const bookingDetails = useSelector(
    (state) => state?.addReservation?.bookingResponse?.data,
  );

  const dutyTypeDetails = bookingDetails?.childData;

  const updateAssignSubVendorSuccess = useSelector(
    (state) =>
      state?.userUpdateAssignSubVendor?.userUpdateAssignSubVendor?.data,
  );
  const assignDriver = useSelector(
    (state) => state?.userUpdateAssignVehicle?.userUpdateAssignVehicle?.data,
  );

  const handlePage = () => {
    if (
      pageName === "assignDriver" ||
      pageName === "assignVehicle" ||
      pageName === "companyDetails"
    ) {
      toggle();
    } else {
      navigate("/reservation");
    }
  };

  const documents = companyProfile?.Contracts?.[0]?.Agreements;

  const contractText = companyProfile?.Contracts?.[0]?.AdditionalDocuments;

  return (
    <>
      <Modal
        open={open || false}
        {...(!isReservationConfirm && { onClose: handlePage })}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="customModal"
      >
        <Box
          className={`modalContent textCenter ${
            pageName === "companyDetails" ? "width600" : "widthFit"
          }`}
        >
          {!isReservationConfirm && (
            <Box className="closeIcon justifyEnd">
              <IconButton aria-label="close" onClick={handlePage}>
                <CloseIcon />
              </IconButton>
            </Box>
          )}

          {pageName === "companyDetails" && (
            <Typography
              variant="head3"
              className="justifyBetween mb10 fw600 colorPrimary"
            >
              New Contract Documents{" "}
            </Typography>
          )}
          {pageName !== "companyDetails" && (
            <Box className="justify-items-center">
              <img src={Confirm} alt="Confirm" />
            </Box>
          )}
          {pageName === "assignDriver" ? (
            <>
              <Typography variant={"head3"} className="fw600 mb10">
                <span className="colorPrimary">Driver Assigned to</span>
                <span className="colorYellow pl10">Sub-vendor</span>
              </Typography>
              <Typography
                variant={"body1"}
                component={"h6"}
                className="fw400 colorBlack mb10"
              >
                Driver Name - {updateAssignSubVendorSuccess?.driverName}
              </Typography>
              <Typography
                variant={"body1"}
                component={"h6"}
                className="fw400 colorBlack mb10"
              >
                Sub-vendor Name - {updateAssignSubVendorSuccess?.subVendorName}
              </Typography>
            </>
          ) : pageName === "assignVehicle" ? (
            <>
              <Typography variant={"head3"} className="fw600 mb10">
                <span className="colorPrimary">Vehicle Assigned to</span>
                <span className="colorYellow pl10">Driver</span>
              </Typography>
              <Typography
                variant={"body1"}
                component={"h6"}
                className="fw400 colorBlack mb10"
              >
                Vehicle name - {assignDriver?.vehicleType}
              </Typography>
              <Typography
                variant={"body1"}
                component={"h6"}
                className="fw400 colorBlack mb10"
              >
                Vehicle Number - {assignDriver?.vehicleNumber}
              </Typography>
              <Typography
                variant={"body1"}
                component={"h6"}
                className="fw400 colorBlack mb10"
              >
                Driver Name - {assignDriver?.driverName}
              </Typography>
            </>
          ) : pageName === "companyDetails" ? (
            <>
              {companyProfile?.Contracts?.[0]?.Agreements?.length > 0 ? (
                <Grid container className="heightModelScroll">
                  {contractText.length > 0 && (
                    <Typography
                      variant="body1"
                      className="justifyBetween mb10 colorGrey"
                    >
                      Contracts
                    </Typography>
                  )}
                  {companyProfile?.Contracts?.[0]?.Agreements?.map(
                    (agreement, index) => {
                      if (agreement.id) {
                        let fileName = agreement?.agreement?.name || "";
                        let fileType = fileName.split(".").pop();
                        return (
                          <Grid
                            item
                            xs={12}
                            className="bgViolet justifyBetween mb10"
                          >
                            <Tooltip
                              title={agreement?.agreement?.name}
                              placement="bottom"
                            >
                              <Typography
                                variant={"body2"}
                                className="colorBlack fw400 p20 marginBlock10 alignItem"
                              >
                                <img
                                  src={fileType === "pdf" ? pdf : word}
                                  alt="Download Icon"
                                />
                                {truncateComment(
                                  agreement?.agreement?.name,
                                  20,
                                )}
                              </Typography>
                            </Tooltip>
                            <a
                              href={agreement?.agreement?.url}
                              download={agreement?.agreement?.name}
                              target="_blank"
                            >
                              <img
                                src={DownloadIcon}
                                alt="ArrowDown"
                                className="cursor p20"
                              />
                            </a>
                          </Grid>
                        );
                      }
                      return null;
                    },
                  )}
                  {documents?.length > 0 && (
                    <Typography
                      variant="body1"
                      className="justifyBetween mb10 colorGrey"
                    >
                      Other Documents
                    </Typography>
                  )}

                  {companyProfile?.Contracts?.[0]?.AdditionalDocuments?.map(
                    (agreement, index) => {
                      if (agreement.id) {
                        let docName = agreement?.file?.name || "";
                        let docType = docName.split(".").pop();
                        return (
                          <Grid
                            item
                            xs={12}
                            className="bgViolet justifyBetween mb10"
                          >
                            <Tooltip
                              title={agreement?.file?.name}
                              placement="bottom"
                            >
                              <Typography
                                variant={"body2"}
                                className="colorBlack fw400 p20 marginBlock10 alignItem"
                              >
                                <img
                                  src={docType === "pdf" ? pdf : word}
                                  alt="Download Icon"
                                />
                                {truncateComment(agreement?.file?.name, 20)}
                              </Typography>
                            </Tooltip>
                            <a
                              href={agreement?.file?.url}
                              download={agreement?.file?.name}
                              target="_blank"
                            >
                              <img
                                src={DownloadIcon}
                                alt="ArrowDown"
                                className="cursor p20"
                              />
                            </a>
                          </Grid>
                        );
                      }
                      return null;
                    },
                  )}
                </Grid>
              ) : (
                <CommonNoDataFound />
              )}
            </>
          ) : (
            <>
              <Typography variant={"head3"} className="fw600 mb10">
                <span className="colorPrimary">Reservation</span>
                {bookingDetails?.childData?.billingType ===
                billingTypeEnum?.billToCreditCard ? (
                  <span className="colorYellow pl10">Done</span>
                ) : (
                  <span className="colorYellow pl10">Confirm</span>
                )}
              </Typography>
              <Typography
                variant={"body2"}
                component={"h6"}
                className="fw400 mb10"
              >
                Booking ID - {bookingDetails?.trip?.tripId}
              </Typography>
              <Tooltip
                title={
                  bookingDetails?.trip?.sourceAddress ||
                  bookingDetails?.trip?.sourceLandMarkAddress
                }
                placement="bottom"
              >
                <Typography
                  variant={"body3"}
                  component={"h6"}
                  className="fw400 colorGrey mb10"
                >
                  From -&nbsp;
                  {truncateComment(
                    bookingDetails?.trip?.sourceAddress ||
                      bookingDetails?.trip?.sourceLandMarkAddress,
                    30,
                  ) || "NA"}
                </Typography>
              </Tooltip>

              {bookingDetails?.trip?.sourceLandMarkAddress && (
                <Tooltip
                  title={bookingDetails?.trip?.sourceLandMarkAddress}
                  placement="bottom"
                >
                  <Typography
                    variant={"body3"}
                    component={"h6"}
                    className="fw400 colorGrey mb10"
                  >
                    Landmark -&nbsp;
                    {truncateComment(
                      bookingDetails?.trip?.sourceLandMarkAddress,
                      30,
                    ) || "NA"}
                  </Typography>
                </Tooltip>
              )}

              {(dutyTypeDetails?.tripAddress ||
                dutyTypeDetails?.destinationAddress) && (
                <Tooltip
                  title={
                    dutyTypeDetails?.tripAddress ||
                    dutyTypeDetails?.destinationAddress
                  }
                  placement="bottom"
                >
                  <Typography
                    variant={"body3"}
                    component={"h6"}
                    className="fw400 colorGrey mb10"
                  >
                    To -&nbsp;
                    {dutyTypeDetails.destinationAddress
                      ? truncateComment(dutyTypeDetails.destinationAddress, 30)
                      : truncateComment(dutyTypeDetails.tripAddress, 30)}
                  </Typography>
                </Tooltip>
              )}

              {bookingDetails?.childData?.billingType ===
                billingTypeEnum?.billToCreditCard && (
                <Typography
                  variant={"head5"}
                  component={"h6"}
                  className="fw500 mb10 width600 colorBlack"
                >
                  To confirm your booking, kindly proceed with the payment
                  process using the link sent via email.
                </Typography>
              )}

              <Typography
                variant={"head5"}
                component={"h6"}
                className="fw600 colorBlack"
              >
                Ride details will be shared with&nbsp;
                {bookingDetails?.passengerName || "NA"}
              </Typography>

              <Box className="justifyEnd mt10">
                <CommonButton
                  name="Notify Recipients"
                  btnClass="btnMedium"
                  onClick={() => {
                    toggle();
                    setNotifyModalOpen(true);
                  }}
                />
              </Box>
            </>
          )}
        </Box>
      </Modal>

      <NotifyRecipientsModal
        open={notifyModalOpen}
        toggle={() => setNotifyModalOpen(false)}
        navigate={navigate}
        tripId={bookingDetails?.trip?.id}
        notificationType="bookingConfirmation"
      />
    </>
  );
};

export default ConfirmModal;
